module.exports = __webpack_public_path__ + "img/provider.0d32ee83.jpg";